import { createContext, useContext, useState } from "react";

type UpsellDialogContextType = {
  isUpsellOpen: boolean;
  openUpsell: () => void;
  closeUpsell: () => void;
};

const UpsellDialogContext = createContext<UpsellDialogContextType | undefined>(
  undefined
);

export function UpsellDialogProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isUpsellOpen, setIsUpsellOpen] = useState(false);

  const openUpsell = () => setIsUpsellOpen(true);
  const closeUpsell = () => setIsUpsellOpen(false);

  return (
    <UpsellDialogContext.Provider
      value={{
        isUpsellOpen,
        openUpsell,
        closeUpsell,
      }}
    >
      {children}
    </UpsellDialogContext.Provider>
  );
}

export function useUpsellDialog() {
  const context = useContext(UpsellDialogContext);
  if (context === undefined) {
    throw new Error(
      "useUpsellDialog must be used within a UpsellDialogProvider"
    );
  }
  return context;
}
